module.exports = __webpack_public_path__ + "static/budzet-55ea3b5ce627a8d514f3d25f94a6d9d4.jpg";